import React from 'react';
import { Box, Typography, Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        background: 'rgba(18, 18, 18, 0.95)',
        color: 'rgba(255, 255, 255, 0.7)',
        py: 3,
        px: { xs: 2, sm: 3 },
        mt: 'auto',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
      }}
    >
      <Box
        sx={{
          maxWidth: 'md',
          mx: 'auto',
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontWeight: 300,
            color: 'rgba(255, 255, 255, 0.7)',
            textAlign: { xs: 'center', sm: 'left' },
          }}
        >
          {t('footer.copyright', { year: currentYear })}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: { xs: 1, sm: 3 },
            alignItems: 'center',
          }}
        >
          <MuiLink
            component={RouterLink}
            to="/privacy-policy"
            sx={{
              color: '#2196F3',
              textDecoration: 'none',
              fontWeight: 300,
              '&:hover': { textDecoration: 'underline' },
            }}
          >
            {t('footer.privacyPolicy')}
          </MuiLink>
          <MuiLink
            component={RouterLink}
            to="/cookies-policy"
            sx={{
              color: '#2196F3',
              textDecoration: 'none',
              fontWeight: 300,
              '&:hover': { textDecoration: 'underline' },
            }}
          >
            {t('footer.cookiesPolicy')}
          </MuiLink>
          <MuiLink
            component={RouterLink}
            to="/terms-and-conditions"
            sx={{
              color: '#2196F3',
              textDecoration: 'none',
              fontWeight: 300,
              '&:hover': { textDecoration: 'underline' },
            }}
          >
            {t('footer.termsAndConditions')}
          </MuiLink>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;